import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import PageLayout from "examples/LayoutContainers/PageLayout";
import Loader from "examples/Loader";
import React, { useEffect, useState } from "react";
import Tabs from "../components/Tabs";
import Blogs from "./components/blogs";
import Jobs from "./components/jobs";
import News from "./components/news";
import Events from "./components/events";
import breakpoints from "assets/theme/base/breakpoints";
import { useAppServices } from "hook/services";
import { useAgencyInfo } from "context/agency";

const Submissions = () => {
  const { values } = breakpoints;
  const [loader, setloader] = useState(true);
  const [List, setList] = useState([]);
  const AppService = useAppServices();
  const [agency] = useAgencyInfo();
  const onLoad = async () => {
    const { response } = await AppService.agency.GetSubmissions({
      query: `agency_id=${agency._id}`,
    });
    if (response) {
      setList(response?.data || []);
      setloader(false);
    }
  };

  useEffect(() => {
    onLoad();
  }, []);

  return loader ? (
    <Loader />
  ) : (
    <PageLayout>
      <SoftBox alignItems="center">
        <div
          className="d-flex w-100 align-items-center"
          style={{ justifyContent: "space-between" }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <SoftTypography
              variant={window.innerWidth < values.sm ? "h3" : "h2"}
              textTransform="capitalize"
              fontWeight="600"
            >
              Submissions
            </SoftTypography>
          </div>
        </div>
        <Tabs
          tabsData={[
            {
              label: `Blogs (${List?.blogs?.length})`,
              content: <Blogs data={List?.blogs} onLoad={onLoad} agency={agency} />,
            },
            {
              label: `Jobs (${List?.jobs?.length})`,
              content: <Jobs data={List?.jobs} onLoad={onLoad} agency={agency} />,
            },
            {
              label: `News (${List?.news?.length})`,
              content: <News data={List?.news} onLoad={onLoad} agency={agency} />,
            },
            {
              label: `Events (${List?.events?.length})`,
              content: <Events data={List?.events} onLoad={onLoad} agency={agency} />,
            },
          ]}
        />
      </SoftBox>
    </PageLayout>
  );
};
export default Submissions;
